<!--
 * @Author: your name
 * @Date: 2021-04-14 15:31:09
 * @LastEditTime: 2021-04-15 14:56:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/Details.vue
-->

<template>
  <Nav-bar :has_back="true" :has_right="false" title="发票详情"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <div class="display_flex">
      <img src="@/images/receipt_details_title.png" class="title-icon" />
      <span class="t-f14-c1a m-l-10">开票状态</span>
    </div>
    <div class="status-container">
      <span class="t-f14-c1a" :style="{ color: invoicesData.statusColor }">{{ invoicesData.statusName }}</span>
      <span class="t-f14-c66 m-l-10">{{
        $filters.timeFormate(invoicesData.updated_at)
      }}</span>
    </div>
    <div class="t-f14-c1a font-bold m-t-10">发票详情</div>
    <div class="item-container m-t-10">
      <div class="item-v display_flex">
        <span class="t-f14-c66">抬头全称</span>
        <span class="t-f14-c1a c-t">{{ invoicesData.title }}</span>
      </div>  
      <div class="item-v display_flex">
        <span class="t-f14-c66">发票内容</span>
        <span class="t-f14-c1a c-t">充电服务费</span>
      </div>
      <div class="item-v display_flex">
        <span class="t-f14-c66">发票金额</span>
        <span class="t-f14-cf19321 c-t">{{ invoicesData.total_amount }}</span>
      </div>
      <div class="item-v display_flex">
        <span class="t-f14-c66">发票类型</span>
        <span class="t-f14-c1a c-t"
          >{{
            invoicesData.title_genre == "company" ? "企业" : "个人"
          }}-电子发票</span
        >
      </div>
      <div class="item-v display_flex" style="border: none" @click="toInclude">
        <span class="t-f14-c66">所含内容</span>
        <span class="t-f14-cf19321 c-t"
          >{{ invoicesData.orders.length }} 个订单</span
        >
        <img src="@/images/arrows.png" class="r-i arrows-icon" />
      </div>
    </div>
    <div class="t-f14-c1a font-bold m-t-10">收件信息</div>
    <div class="item-container m-t-10">
      <div class="item-v display_flex border_none">
        <span class="t-f14-c66">电子邮件</span>
        <span class="t-f14-c1a c-t">{{ invoicesData.email }}</span>
      </div>
    </div>
    <!-- <div class="m-20">
      <van-button type="primary" size="normal" class="main-btn"
        >取消开票</van-button
      >
    </div> -->
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import request from "@/api/request";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ref } from "vue";
let storeContext;
let router;
let invoicesData = ref("");
export default {
  components: {
    NavBar,
  },

  setup() {
    router = useRouter();
    storeContext = useStore();
    const id = router.currentRoute.value.params.id;
    apiGetInvoicesDetails(id);
    return { invoicesData, toInclude };
  },
};
//包含订单列表
function toInclude() {
  storeContext.commit("setInvoices", {
    invoicesList: invoicesData.value.orders,
  });
  router.push("/user/receipt/include_list");
}
function apiGetInvoicesDetails(id) {
  request.getInvoicesDetails(id).then((res) => {
    invoicesData.value = formatData(res.data);
  });
}
function formatData(data) {
  if (data.status == "initial") {
    data.statusName = "待审核";
    data.statusColor = "#F19321";
  }
  if (data.status == "pending") {
    data.statusName = "待审核";
    data.statusColor = "#F19321";
  }
  if (data.status == "passed") {
    data.statusName = "已开票";
    data.statusColor = "#00B68A";
  }
  if (data.status == "rejected") {
    data.statusName = "未通过";
    data.statusColor = "#F64A4A";
  }
  return data;
}
</script>
<style scoped>
.container {
  padding: 12px 20px;
}
.status-container {
  background: #fff;
  border-radius: 5px;
  margin-top: 10px;
  position: relative;
  padding: 12px 10px;
}
.title-icon {
  width: 18px;
  height: 18px;
}
.item-v {
  border-bottom: 1px #ebebeb solid;
  position: relative;
  line-height: 44px;
}
.c-t {
  position: absolute;
  left: 115px;
  top: 50%;
  transform: translateY(-50%);
}
.item-container {
  background: #fff;
  padding: 0px 10px;
  border-radius: 5px;
}
.r-i {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>